import React, { useEffect, useState } from 'react'
import images from 'assets/images/images'
import AddressCard from 'components/address/AddressCard'
import Drawer from 'react-modern-drawer'
import AddressAddDrawer from './../components/address/AddressAddDrawer';
import { useRequest } from 'hooks/useRequest'
import { useDispatch, useSelector } from 'react-redux'
import { currentLocationFunc, updateAddressFunc } from 'redux/features/general/generalSlice'
import LoaderTwo from './LoaderTwo'
import useFilterSearch from 'hooks/useFilterSearch'
import useTranslate from 'hooks/useTranslate'
import {Helmet} from 'react-helmet'
import Breadcrumbs from 'components/Breadcrumbs'

const Address = () => {
    const [isOpenDrawer, setIsOpenDrawer] = useState(false)
    const [getAddress,setGetAddress] = useState([])
    const [request,loading] = useRequest();
    const {useTrigger} = useSelector(state => state.general)
    const dispatch = useDispatch();
    const [filteredAddressess, handleFilterChange, setFilteredAddresses] = useFilterSearch(getAddress)
    const {t} = useTranslate()
    const [addressInfo, setAddressInfo] = useState({
        firstName: "",
        lastName: "",
        addressTitle: "",
        province: "",
        provinceId: null,
        district: "",
        districtId: null,
        neighbourhood: "",
        neighbourhoodId: null,
        street: "",
        streetId: null,
        building: "",
        buildingId: null,
        floor: "",
        apartment: "",
        addressDescription: "",
        latitude: null,
        longitude: null,
        countryCode: "",
        phone: ""
      })


    useEffect(() => {
         request('/Profile/Addresses', {
            method: "GET"
         })
         .then((res) => {
            if(res){
               setGetAddress(res.data.result)  
               setFilteredAddresses(res.data.result)
            }
         } )
    }, [useTrigger])

    const addAddressDrawer = () => {
        //buraya farklı kısımlar gelecek....
        dispatch(currentLocationFunc({}))
        dispatch(updateAddressFunc({}))
        setAddressInfo({})
        setIsOpenDrawer(!isOpenDrawer)
    }
    return (
        <div className='address-bgColor'>
            <LoaderTwo isDataLoading={loading} />
            <Helmet>
                <title>{t('myAddresses')}</title>
            </Helmet>
            <div className='address'>
                <Breadcrumbs 
                    className={'breadcrumbs'}
                    breadcrumbList={[
                        {text:t('homePage'), link:'/'},
                        {text:t('myAddresses'), link:'/'},
                    ]} 
                />
                <div className="address-container">
                    <h1 className='header-m2 mb-4'>{t('myAddresses')}</h1>
                    {
                        getAddress.length > 0 && <input type="text" onChange={(e) => handleFilterChange(e.target.value)} placeholder={t('searchInAddresses')} className="form-control-input" />
                    }
                    {
                        filteredAddressess.map((item, i) => (
                            <AddressCard key={i} item={item} setIsOpenDrawer={setIsOpenDrawer} isOpenDrawer={isOpenDrawer} />
                        ))
                    }
                    <div onClick={addAddressDrawer} className='address-container-btn'>
                        <img src={images.plus2} alt="" />
                        <div>{t('addAddress')}</div>
                    </div>
                </div>

                <Drawer
                    open={isOpenDrawer}
                    onClose={() => setIsOpenDrawer(!isOpenDrawer)}
                    direction='right'
                    className='addressAddDrawer'
                >
                    <AddressAddDrawer isOpenDrawer={isOpenDrawer} addressInfo={addressInfo} setAddressInfo={setAddressInfo} setIsOpenDrawer={setIsOpenDrawer} />
                </Drawer>
            </div>
        </div>
    )
}

export default Address